/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.SalesMenu = function( arCmd, listClass) {
    var fxStyle = expocadfx.styles;
    var numCmds = arCmd.length;
    var i = 0;
    var item = null;
    var ul = document.createElement( "ul");
	ul.setAttribute( "class", listClass);
    ul.setAttribute( "id", "salesmenu");
	ul.style.zIndex = "31";
    ul.style.background = fxStyle.view.clrBg !== "" ? fxStyle.view.clrBg : fxStyle.mainHeader.clrBg;
    for( i = 0; i < numCmds; i++) {
        item = document.createElement( "li");
        if( i % 2 === 0) {
            item.setAttribute( "class", "salesItem even");
        }
        else {
            item.setAttribute( "class", "salesItem odd");
        }
        item.textContent = arCmd[i];
        item.style.cursor = "pointer";
        ul.appendChild( item);
        item.addEventListener('click', function(e){
            window.setTimeout(function(){
                var salesHeader = document.getElementById('salesHeader');
                salesHeader.innerHTML = e.target.innerText;
            }, 100)
        })
    }
    return ul;
};